export const ShipmentReturnPage = () => {
  return <>ShipmentReturnPage</>;
};
